import { ParamKeyValuePair } from 'react-router-dom';
import {
  DataTableDataSearchDto,
  DetailPageDto,
} from '@asset-metrix/portal-gateway-client-js';

import { NO_ROLE_ID } from '../../api/portalGatewayClient';
import { DETAILS_PAGE_URL_DISCRIMINATOR_PARAM } from '../../utils/constants';
import { selectionToKeyValuePairs } from '../../utils/filtersToKeyValuePairs';
import { pageWithRoleLink } from '../../utils/urlPath';

export function getDetailPageUrl(
  roleId: string,
  detailPageConfig: DetailPageDto,
  pageFilterSelections: DataTableDataSearchDto['selection'] | undefined,
  dataRows: Record<string, unknown>[]
): string {
  const href = pageWithRoleLink(roleId ?? NO_ROLE_ID, {
    slug: detailPageConfig.completeSlug,
    pageType: 'detailPage',
  });

  const detailsIdKey = detailPageConfig.detailsIdKey;
  let filterKeyValuePairs: ParamKeyValuePair[] = [];
  if (pageFilterSelections != null) {
    const { [detailsIdKey]: _, ...rest } = pageFilterSelections;
    for (const [key, selection] of Object.entries(rest)) {
      filterKeyValuePairs.push(...selectionToKeyValuePairs(key, selection));
    }
  }

  // add configured detail page params
  filterKeyValuePairs.push([
    DETAILS_PAGE_URL_DISCRIMINATOR_PARAM,
    detailsIdKey,
  ]);

  for (const data of dataRows) {
    if (data?.[detailsIdKey] != null) {
      // add details filters & discriminator to params (identifies nav-item on deep-links)
      filterKeyValuePairs.push([detailsIdKey, String(data[detailsIdKey])]);
    }

    // add other columns configured as filters
    for (const key of detailPageConfig.additionalFilterColumnKeys) {
      // remove existing pagefilter entries if pagefilters and additionalFilterColumns share a key
      // the additionalFilterColumn beats the pagefilters in this case
      filterKeyValuePairs = filterKeyValuePairs.filter(([filterKey]) => {
        return filterKey !== key;
      });
      filterKeyValuePairs.push([key, String(data[key])]);
    }
  }

  return `${href}?${new URLSearchParams(filterKeyValuePairs).toString()}`;
}
